import { useRef, useState } from 'react';

export type TTimeStatus = 'waiting' | 'progress';

interface IReturnOptions {
    timeStatus: TTimeStatus,
    seconds: number,
    start: (seconds: number) => void,
    stop: () => void,
}

/**
 * Таймер обратного отсчета
 * @returns {[string, number, function: void, function: void]} Текущий статус, текущая секунда, колбэк запуска, колбэк остановки
 */
export const useTimer = (): IReturnOptions => {
    const [{
        currentSecond,
        state,
    }, setState] = useState<{ currentSecond: number, state: TTimeStatus }>({
        currentSecond: 0,
        state: 'waiting',
    });
    const intervalId = useRef<ReturnType<typeof setInterval> | null>(null);

    const handleTick = () => {
        setState(prev => {
            if (prev.currentSecond > 1) {
                return { ...prev, currentSecond: prev.currentSecond - 1 };
            } else {
                return { ...prev, currentSecond: 0, state: 'waiting' };
            }
        });
    };

    const handleStop = () => {
        if (intervalId.current) {
            clearInterval(intervalId.current);
            intervalId.current = null;
        }
    };

    const start = (seconds: number) => {
        handleStop();
        setState(prev => ({ ...prev, currentSecond: seconds, state: 'progress' }));
        intervalId.current = setInterval(handleTick, 1000);
    };

    const stop = () => {
        setState(prev => ({ ...prev, state: 'waiting' }));
        handleStop();
    };

    return { timeStatus: state, seconds: currentSecond, start, stop };
};
